<template>
  <router-link :to="{ name: homeRoute }" class="logo-container">
    <div class="logo-inner">
      <img :src="company.logo" :alt="$t(`global.${company.name}`)" />
    </div>
  </router-link>
</template>

<script>
import { constants } from "@/utils";
import useCompany from "@/utils/useCompany";

export default {
  name: "NavLogo",
  setup() {
    const { company } = useCompany();
    const homeRoute = constants.HOME_ROUTE;
    return {
      company,
      homeRoute,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.logo-container {
  padding: 12px $nav-padding-side;
  height: $header-height;
  flex-grow: 0;
  display: block;

  .logo-inner {
    height: 100%;

    img {
      height: 100%;
    }
  }
}
</style>
